import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Expertise } from '../../shared/models/expertise';
import { FormBuilder, FormArray, FormGroup, Validators, ValidationErrors, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { TarifCodeService } from 'src/app/shared/services/tarif-code.service';

@Component({
  selector: 'app-expertise-tarif-edit',
  templateUrl: './expertise-tarif-edit.component.html',
  styleUrls: ['./expertise-tarif-edit.component.scss']
})
export class ExpertiseTarifEditComponent implements OnInit {

	@Input() expertise: Expertise;


	@Output() cancel: EventEmitter<any> = new EventEmitter();
	@Output() save: EventEmitter<any> = new EventEmitter();

	form: FormGroup;
	public tarifs: any[] = [];
	constructor(
		private fb: FormBuilder,
		private tarifCodeService: TarifCodeService

    ) { }

	ngOnInit() {
		this._buildForm();
	}

	onCancel() {
		this.cancel.emit();
	}

	onSave() {
		let c = Object.assign((new Expertise()), this.expertise, this.form.value, {
			tarifs: this.tarifs.reduce((acc, cur) => ({...acc, ['tarif'+cur.id]: this.form.value['tarif'+cur.id]}), {})
		});
		this.save.emit(c.toRequest());
	}

	_buildForm() {
		this.tarifCodeService.get().pipe(
			).subscribe(t => {
				this.tarifs = t;
				this.form = this.fb.group({
					...this.tarifs.reduce((acc, cur) => ({...acc, ['tarif'+cur.id]: [this.expertise.tarifs['tarif' +cur.id], [Validators.required]]}), {}),
					'acompte': [ this.expertise.acompte, [ Validators.required ] ],
					'open_fee': [ this.expertise.open_fee, [ Validators.required ] ],
					'pct_base_satellite': [ this.expertise.pct_base_satellite, [ Validators.required ] ],
					'pct_base_collaborateur': [ this.expertise.pct_base_collaborateur, [ Validators.required ] ],
					'collaborateurs':this.fb.array(this._buildCollaborateurForm()),
				});


			});
	}
	_buildCollaborateurForm() {
		return this.expertise.collaborateurs.map(c => this.fb.group({
			't_hrs': [ c.t_hrs, [ Validators.required ] ],
			't_km': [ c.t_km, [ Validators.required ] ],
			'user': [c.user,[]]
		}));
	}

	getCollaborateurs(): FormArray {
		return <FormArray>this.form.get('collaborateurs');
	}

}
